import { instBundle } from '../axios';

const axios = instBundle.axiosAdminJS;

class AdService {
	/**
	 * 지정한 조건의 광고집계 데이터 목록을 조회한다.
	 * @param {*} ad_code
	 * @param {*} ref_ids
	 * @returns Object of response
	 */
	getTargetAdList(ad_code, ref_ids) {
		return axios
			.get('/ad/target', {
				params: {
					ad_code,
					ref_ids: ref_ids.join(','),
				},
			})
			.then(rs => rs.data);
	}
}

export default new AdService();
